export default "__VITE_ASSET__DzHUmYSb__"